import React, { useContext } from "react";
import i18n from "~/assets/js/Helpers/i18n";
import { ForwardButton } from "~/assets/js/components/Button";
import {
    CheckoutContext,
    ACTIONS,
    PAGES,
} from "~/assets/js/pages/Checkout/CheckoutProvider";
import Headline from "~/assets/js/components/Typography/Headline";

const NewCustomer = () => {
    const { dispatch } = useContext(CheckoutContext);

    const nextPage = (page) => {
        return dispatch({ type: ACTIONS.CHANGE_PAGE, payload: page });
    };

    return (
        <div id="new-customer">
            <Headline size={5} resizable>
                {i18n.t("login.newCustomer.title")}
            </Headline>
            <p id="new-customer__text">{i18n.t("login.newCustomer.text")}</p>
            <div id="new-customer__CTA">
                <ForwardButton
                    size="SM"
                    variant="primary"
                    label={i18n.t("login.newCustomer.register")}
                    onClick={() => nextPage(PAGES.REGISTER)}
                />
                <ForwardButton
                    size="SM"
                    variant="secondary"
                    label={i18n.t("login.newCustomer.continueGuest")}
                    onClick={() => nextPage(PAGES.CONTACT_DETAILS)}
                />
            </div>
        </div>
    );
};

export default NewCustomer;
